import { render, staticRenderFns } from "./OrdersCaList.vue?vue&type=template&id=82b328bc&scoped=true"
import script from "./OrdersCaList.vue?vue&type=script&lang=js"
export * from "./OrdersCaList.vue?vue&type=script&lang=js"
import style0 from "./OrdersCaList.vue?vue&type=style&index=0&id=82b328bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b328bc",
  null
  
)

export default component.exports